<template>
  <div class="page-container">
    <main :class="['main-content', { nested: isMemberCenterContext }]">
      <div class="page-inner-box">

        <div class="my-courses-container">
          
          <div class="content-main">

            <!-- 顶部用户信息 (已移至左侧边栏) -->
            
            <!-- 统计信息 -->
            <div class="stats-info" :class="{ 'no-gold': !showGold }" v-loading="overviewLoading">
              <div class="stat-item" @click="switchToMessages" style="cursor: pointer;">
                <div class="stat-label">
                  我的通知
                  <span v-if="overview.unreadMessageCount > 0" class="stat-badge-count">{{ overview.unreadMessageCount }}</span>
                </div>
                <div class="stat-value">{{ overview.unreadMessageCount }}</div>
              </div>
              <div class="stat-item" @click="backToCourses" style="cursor: pointer;">
                <div class="stat-label">我的课程</div>
                <div class="stat-value">{{ overview.courseCount }}</div>
              </div>
              <div class="stat-item" @click="switchToCertificates" style="cursor: pointer;">
                <div class="stat-label">我的证书</div>
                <div class="stat-value">{{ overview.certificateCount }}</div>
              </div>
              <div class="stat-item" @click="switchToCollections" style="cursor: pointer;">
                <div class="stat-label">我的收藏</div>
                <div class="stat-value">{{ overview.collectionCount || '' }}</div>
              </div>
              <div v-if="showGold" class="stat-item">
                <div class="stat-label">金币总额</div>
                <div class="stat-value">{{ overview.goldCount }}</div>
              </div>
            </div>
            
            <!-- 我的课程 -->
            <div class="courses-section">
              <!-- 课程列表视图 -->
              <div v-if="currentView === 'courses'">
                <div class="section-header">
                  <div class="section-title">我的课程</div>
                  <div class="section-actions">
                    <el-button type="primary" size="small" class="exchange-btn" @click="switchToExchange">课程兑换</el-button>
                  </div>
                </div>
                
                <div v-loading="myCoursesLoading" class="courses-grid">
                  <!-- 课程卡片 -->
                  <div v-for="course in courses" :key="course.id" class="course-card" @click="goStudy(course)">
                    <div class="card-inner">
                      <div class="course-image">
                        <img v-if="course.coverImage" class="course-cover" :src="course.coverImage" alt="">
                      </div>
                      <div class="course-content">
                        <div class="course-title">{{ course.title }}</div>
                        <div class="course-progress" style="margin-top: 8px; margin-bottom: 4px; font-size: 12px; color: #999; display: flex; justify-content: space-between; align-items: center;">
                          <span>学习进度: {{ course.studyProgressPercent != null ? course.studyProgressPercent : '0' }}%</span>
                          <span v-if="course.remainingDaysUntilExpire != null" :style="{ color: course.remainingDaysUntilExpire <= 0 ? '#f56c6c' : '#999' }">
                            {{ course.remainingDaysUntilExpire > 0 ? `剩${course.remainingDaysUntilExpire}天过期` : course.remainingDaysUntilExpire === 0 ? '今天过期' : '已过期' }}
                          </span>
                          <span v-else>永久有效</span>
                        </div>
                        <div class="course-tags">
                          <span class="course-tag">建工安全</span>
                        </div>
                        <div class="course-footer">
                          <span class="price">¥{{ course.price }}</span>
                          <span class="lessons-count">共{{ course.lessons }}节</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- 课程兑换视图 -->
              <div v-else-if="currentView === 'exchange'" class="exchange-section">
                <div class="section-header exchange-header">
                  <div class="section-title">我的课程</div>
                  <div class="back-link" @click="backToCourses">
                    返回我的课程 <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                
                <div class="exchange-container">
                  <div class="form-group">
                    <el-input v-model="exchangeCode" placeholder="请输入兑换码" class="custom-input large-input"></el-input>
                  </div>
                  
                  <div class="form-group verify-group">
                    <el-input v-model="password" placeholder="请输入卡密" class="custom-input large-input"></el-input>
                    <el-button :disabled="redeemSubmitting" type="primary" class="verify-btn" @click="verifyExchangeCode">验证兑换码</el-button>
                  </div>
                  
                  <div class="exchange-result-card">
                    <div class="result-row">
                      <span class="label">兑换码：</span>
                      <span class="val">{{ exchangeInfo.code }}</span>
                    </div>
                    <div class="result-row">
                      <span class="label">可兑换：</span>
                      <span class="val">{{ exchangeInfo.course }}</span>
                    </div>
                    <div class="result-row">
                      <span class="label">有效期：</span>
                      <span class="val">{{ exchangeInfo.validPeriod }}</span>
                    </div>
                    <div class="result-row">
                      <span class="label">说&emsp;明：</span>
                      <span class="val">{{ exchangeInfo.description }}</span>
                    </div>
                  </div>
                  
                  <el-button :loading="redeemSubmitting" type="primary" class="confirm-btn" @click="confirmExchange">确认兑换</el-button>
                  
                  <div class="usage-instructions">
                    <div class="instruction-title">使用说明:</div>
                    <p>1.一张券只能绑定一个用户，以兑换时间先后为准。</p>
                    <p>2.兑换券可以在兑换专区兑换指定的商品。</p>
                    <p>3.兑换券不可以兑换成现金</p>
                    <p>4.兑换卡ID为卡片上5位数字</p>
                    <p>5.如果兑换中遇到问题请及时联系我们的客服为您解决。</p>
                  </div>

                  <div class="redeem-records">
                    <div class="instruction-title">我的兑换记录</div>
                    <el-table v-loading="redeemRecordsLoading" :data="redeemRecords" size="mini" style="width: 100%">
                      <el-table-column prop="code" label="兑换码" min-width="140"></el-table-column>
                      <el-table-column prop="name" label="内容" min-width="200"></el-table-column>
                      <el-table-column prop="time" label="兑换时间" min-width="160"></el-table-column>
                      <el-table-column prop="status" label="状态" width="120"></el-table-column>
                    </el-table>
                    <el-empty v-if="!redeemRecordsLoading && redeemRecords.length === 0" description="暂无兑换记录" />
                  </div>
                </div>
              </div>
              
              <!-- 设置页面视图 -->
              <div v-else-if="currentView === 'settings'" class="settings-section">
                <Settings :userInfo="settingsUserInfo" :loginPassword="loginPassword" />
              </div>
              
              <!-- 我的收藏视图 -->
              <div v-else-if="currentView === 'collections'">
                <div class="section-header">
                  <div class="section-title">我的收藏</div>
                  <div class="section-actions">
                    <el-button type="primary" plain size="small" @click="backToCourses">返回我的课程</el-button>
                  </div>
                </div>
                
                <div class="courses-grid">
                  <!-- 收藏课程卡片 -->
                  <div v-for="course in collections" :key="course.id" class="course-card">
                    <el-card shadow="hover" :body-style="{ padding: '0' }">
                      <div class="course-image">
                        <div class="course-poster">{{ course.title }}</div>
                      </div>
                      <div class="course-content">
                        <div class="course-title">{{ course.title }}</div>
                        <div class="course-status">
                          <el-tag type="success">课工安全</el-tag>
                        </div>
                        <div class="course-price">
                          <span class="price">¥{{ course.price }}</span>
                          <span class="lessons-count">共{{ course.lessons }}节</span>
                        </div>
                      </div>
                    </el-card>
                  </div>
                </div>
              </div>
              
              <!-- 站内信视图 -->
                <div v-else-if="currentView === 'messages'">
                  <div class="section-header">
                    <div class="section-title">站内信</div>
                    <div class="section-actions">
                      <el-button type="primary" plain size="small" @click="backToCourses">返回我的课程</el-button>
                    </div>
                  </div>
                  
                  <Messages />
                </div>
                
                <!-- 我的证书视图 -->
                <div v-else-if="currentView === 'certificates'">
                  <div class="section-header">
                    <div class="section-title">我的证书</div>
                    <div class="section-actions">
                      <el-button type="primary" plain size="small" @click="backToCourses">返回我的课程</el-button>
                    </div>
                  </div>
                  <MyCertificates />
                </div>
                
                <!-- 分销权益视图 -->
                <div v-else-if="currentView === 'distributionRights'">
                  <DistributionRights :hasPurchased="hasPurchased" @back-to-courses="backToCourses" @switch-to-withdraw="switchToWithdraw" />
                </div>
                <!-- 提现页面视图 -->
                <div v-else-if="currentView === 'withdraw'">
                  <Withdraw @back="switchToDistributionRights" />
                </div>
                <!-- 我的项目视图 -->
                <div v-else-if="currentView === 'projects'">
                  <Projects @back-to-courses="backToCourses" />
                </div>
                <!-- 模拟练习视图 -->
                <div v-else-if="currentView === 'simulation'">
                  <Simulation @back-to-courses="backToCourses" />
                </div>
            </div>
          </div>
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import Settings from './Settings.vue'
import Messages from './Messages.vue'
import MyCertificates from './MyCertificates.vue'
import DistributionRights from './DistributionRights.vue'
import Withdraw from './Withdraw.vue'
import Projects from './Projects.vue'
import Simulation from './Simulation.vue'
import { mapGetters } from 'vuex'
import { getMyCourses, getMyRedeems, redeemCode, verifyRedeemCode, getMyFavorites } from '@/api/courseApi'
import { getPersonalInfo, getPersonalOverview } from '@/api/authApi'

export default {
  name: 'MyCourses',
  components: { Settings, Messages, MyCertificates, DistributionRights, Withdraw, Projects, Simulation },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'userInfo', 'username']),
    isMemberCenterContext() {
      return this.$route.path.startsWith('/member-center')
    },
    displayPhone() {
      if (!this.isLoggedIn) return '未登录'
      const name = String(this.username || '').trim()
      return name || '用户'
    },
    displayLevel() {
      if (!this.isLoggedIn) return ''
      const info = this.userInfo || {}
      return info.levelName || info.level || '普通会员'
    },
    settingsUserInfo() {
      const info = this.userInfo || {}
      const mobile = info.mobile || info.phone || this.username || ''
      const nickname = info.nickname || info.name || ''
      const userId = info.userId || info.id || info.uid || ''
      return {
        avatar: info.avatar || '',
        nickname: nickname || this.displayPhone || '用户',
        phone: this.maskMobile(mobile),
        userId: userId ? String(userId) : ''
      }
    },
    userAvatarUrl() {
      const info = this.userInfo || {}
      return (info && info.avatar) ? String(info.avatar) : ''
    },
    userAvatarText() {
      const name = this.displayPhone || ''
      return name ? String(name).trim().slice(0, 1) : 'U'
    },
    showGold() {
      const fromData = Number(this.distributorLevel || 0)
      const fromStore = Number((this.userInfo && this.userInfo.distributorLevel) || 0)
      return fromData > 0 || fromStore > 0
    }
  },
  data() {
    return {
      activeNav: 'courses',
      currentView: 'courses', // 'courses' or 'exchange' or 'settings' or 'collections' or 'messages' or 'distributionRights' or 'withdraw' or 'projects' or 'simulation'
      myCoursesLoading: false,
      myCoursesTotal: 0,
      myCoursesQuery: {
        courseName: '',
        pageNum: 1,
        pageSize: 10
      },
      courses: [
        { id: 1, title: '系统基于ThinkPHP5.0+vue+...', price: 4999.00, lessons: 24 },
        { id: 2, title: '系统基于ThinkPHP5.0+vue+...', price: 4999.00, lessons: 24 },
        { id: 3, title: '系统基于ThinkPHP5.0+vue+...', price: 4999.00, lessons: 24 }
      ],
      // 收藏课程数据
      collections: [
        { id: 4, title: '系统基于ThinkPHP5.0+vue+...', price: 4999.00, lessons: 24 },
        { id: 5, title: '系统基于ThinkPHP5.0+vue+...', price: 4999.00, lessons: 24 },
        { id: 6, title: '系统基于ThinkPHP5.0+vue+...', price: 4999.00, lessons: 24 }
      ],
      // 课程兑换相关数据
      exchangeCode: '',
      password: '',
      exchangeInfo: {
        code: '',
        course: '',
        validPeriod: '',
        description: ''
      },
      redeemRecords: [],
      redeemRecordsLoading: false,
      redeemSubmitting: false,
      loginPassword: '**********',
      hasPurchased: false, // 是否购买了分销商等级
      distributorLevel: null, // 分销商等级
      overviewLoading: false,
      overview: {
        certificateCount: 0,
        collectionCount: 0,
        courseCount: 0,
        goldCount: 0,
        unreadMessageCount: 0,
        unusedCouponCount: 0
      }
    }
  },
  watch: {
    // 监听路由变化，根据查询参数切换到站内信视图
    '$route'(to) {
      if (to.query.view === 'messages') {
        this.switchToMessages()
      } else if (to.query.view === 'simulation') {
        this.switchToSimulation()
      }
    }
  },
  // 页面加载时检查路由参数
  mounted() {
    this.loadMyCourses()
    this.fetchDistributorStatus()
    this.fetchPersonalOverview()
    if (this.$route.query.view === 'messages') {
      this.switchToMessages()
    } else if (this.$route.query.view === 'simulation') {
      this.switchToSimulation()
    }
  },
  methods: {
    formatRedeemPeriod(startTime, endTime) {
      const start = String(startTime || '').trim()
      const end = String(endTime || '').trim()
      if (start && end) return `${start}至${end}`
      if (start) return start
      if (end) return end
      return ''
    },
    normalizeMyCourse(course, index) {
      const id = (course && (course.id ?? course.courseId ?? course.course_id)) ?? index
      const title =
        (course && (course.title ?? course.courseName ?? course.name ?? course.courseTitle)) || ''
      const coverImage =
        (course && (course.coverImage ?? course.cover_image ?? course.cover ?? course.coverUrl ?? course.cover_url ?? course.image ?? course.imgUrl ?? course.img_url)) || ''
      const priceRaw =
        course && (course.price ?? course.salePrice ?? course.currentPrice ?? course.payAmount ?? course.amount)
      const lessonsRaw =
        course && (course.lessons ?? course.lessonCount ?? course.totalLessons ?? course.chapterCount ?? course.periodCount)

      return {
        id,
        title: String(title || ''),
        coverImage: String(coverImage || '').trim(),
        price: priceRaw == null ? '' : priceRaw,
        lessons: lessonsRaw == null ? '' : lessonsRaw,
        studyProgressPercent: course && course.studyProgressPercent != null ? Number(course.studyProgressPercent) : null,
        remainingDaysUntilExpire: course && course.remainingDaysUntilExpire !== undefined ? course.remainingDaysUntilExpire : null,
        raw: course
      }
    },
    extractListAndTotal(data) {
      const list =
        (Array.isArray(data) && data) ||
        (data && Array.isArray(data.list) && data.list) ||
        (data && Array.isArray(data.records) && data.records) ||
        (data && Array.isArray(data.items) && data.items) ||
        []

      const total =
        (data && (data.total ?? data.count ?? data.totalCount)) ||
        (typeof data === 'object' && !Array.isArray(data) ? list.length : list.length)

      return { list, total: Number(total) || 0 }
    },
    async loadMyCourses() {
      if (this.myCoursesLoading) return
      this.myCoursesLoading = true
      try {
        const res = await getMyCourses(this.myCoursesQuery)
        const data = res && res.data
        const { list, total } = this.extractListAndTotal(data)
        this.courses = list.map((item, index) => this.normalizeMyCourse(item, index))
        this.myCoursesTotal = total
      } catch (err) {
        this.courses = []
        this.myCoursesTotal = 0
        this.$message.error((err && err.message) || '获取我的课程失败')
      } finally {
        this.myCoursesLoading = false
      }
    },
    handleLogout() {
      // 退出登录逻辑
      this.$message({
        message: '退出登录成功',
        type: 'success'
      })
      this.$router.push('/')
    },
    handleMyCourses() {
      // 跳转到我的课程，避免重复导航
      if (this.$route.path !== '/my-courses') {
        this.$router.push('/my-courses').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
    },
    // 切换到课程兑换页面
    switchToExchange() {
      this.currentView = 'exchange'
      this.fetchRedeemRecords()
    },
    // 返回课程列表
    backToCourses() {
      if (this.isMemberCenterContext) {
        this.$router.push('/member-center/courses')
      }
      this.currentView = 'courses'
    },
    // 验证兑换码
    async verifyExchangeCode() {
      const code = String(this.exchangeCode || '').trim()
      const password = String(this.password || '').trim()
      if (!code) {
        this.$message.warning('请输入兑换码')
        return
      }
      if (!password) {
        this.$message.warning('请输入卡密')
        return
      }
      if (this.redeemSubmitting) return
      this.redeemSubmitting = true
      try {
        const res = await verifyRedeemCode({ code, password })
        const data = (res && res.data) || {}
        const period = this.formatRedeemPeriod(data.startTime, data.endTime)
        this.exchangeInfo = {
          code: data.code || code,
          course: data.bindName || this.exchangeInfo.course,
          validPeriod: period || this.exchangeInfo.validPeriod,
          description: data.remark || this.exchangeInfo.description
        }
        this.$message.success('验证成功')
      } catch (err) {
        this.$message.error((err && err.message) || '验证失败')
      } finally {
        this.redeemSubmitting = false
      }
    },
    // 确认兑换
    async confirmExchange() {
      const code = String(this.exchangeCode || '').trim()
      if (!code) {
        this.$message.warning('请输入兑换码')
        return
      }
      const password = String(this.password || '').trim()
      if (!password) {
        this.$message.warning('请输入卡密')
        return
      }
      if (this.redeemSubmitting) return
      this.redeemSubmitting = true
      try {
        const res = await redeemCode({ code, password })
        const data = (res && res.data) || {}
        const period = this.formatRedeemPeriod(data.startTime, data.endTime)
        this.exchangeInfo = {
          code: data.code || code,
          course: data.bindName || data.courseName || data.course || data.name || this.exchangeInfo.course,
          validPeriod: period || data.validPeriod || data.expireTime || data.expireAt || this.exchangeInfo.validPeriod,
          description: data.remark || data.description || this.exchangeInfo.description
        }
        this.$message.success('兑换成功')
        this.exchangeCode = ''
        this.password = ''
        await this.fetchRedeemRecords()
      } catch (err) {
        this.$message.error((err && err.message) || '兑换失败')
      } finally {
        this.redeemSubmitting = false
      }
    },
    async fetchRedeemRecords() {
      if (this.redeemRecordsLoading) return
      this.redeemRecordsLoading = true
      try {
        const res = await getMyRedeems()
        const data = (res && res.data) || []
        const list =
          (Array.isArray(data) && data) ||
          (Array.isArray(data.list) && data.list) ||
          (Array.isArray(data.records) && data.records) ||
          (Array.isArray(data.rows) && data.rows) ||
          []
        this.redeemRecords = list.map(item => {
          const code = (item && (item.code || item.redeemCode || item.exchangeCode)) || ''
          const name =
            (item && (item.courseName || item.course || item.goodsName || item.productName || item.name)) || ''
          const time =
            (item && (item.redeemTime || item.createTime || item.createdAt || item.time)) || ''
          const status =
            (item && (item.statusName || item.status || item.state)) || ''
          return { code, name, time, status, raw: item }
        })
      } catch (err) {
        this.$message.error((err && err.message) || '获取兑换记录失败')
        this.redeemRecords = []
      } finally {
        this.redeemRecordsLoading = false
      }
    },

    // 返回主页面
    backToMain() {
      this.currentView = 'courses'
    },
    // 切换到收藏页面
    switchToCollections() {
      if (this.isMemberCenterContext) {
        this.$router.push('/member-center/collections')
        return
      }
      this.currentView = 'collections'
    },
    // 切换到站内信页面
    switchToMessages() {
      if (this.isMemberCenterContext) {
        this.$router.push('/member-center/messages')
        return
      }
      this.currentView = 'messages'
    },
    // 切换到我的证书页面
    switchToCertificates() {
      if (this.isMemberCenterContext) {
        this.$router.push('/member-center/certificates')
        return
      }
      this.currentView = 'certificates'
    },
    // 切换到分销权益购买页面（未购买视图）
    switchToBuyRights() {
      this.hasPurchased = false
      this.currentView = 'distributionRights'
    },
    switchToDistributionRights() {
      this.hasPurchased = true
      this.currentView = 'distributionRights'
    },
    // 切换到提现页面
    switchToWithdraw() {
      this.currentView = 'withdraw'
    },
    // 切换到我的项目页面
    switchToProjects() {
      this.currentView = 'projects'
    },
    // 切换到模拟练习页面
    switchToSimulation() {
      this.currentView = 'simulation'
    },
    // 跳转到学习页面
    goStudy(course) {
      this.$router.push({ name: 'learn', params: { id: course.id } })
    },
    maskMobile(val) {
      const s = String(val || '').trim()
      if (!s) return ''
      if (s.includes('****')) return s
      if (/^1[3-9]\d{9}$/.test(s)) return s.slice(0, 3) + '****' + s.slice(7)
      return s
    },
    async fetchDistributorStatus() {
      try {
        const res = await getPersonalInfo()
        const data = res && res.data
        if (data) {
          if (this.$store && this.$store.dispatch) {
            this.$store.dispatch('auth/updateUserInfo', data)
          }
          const level = data.distributorLevel
          // distributorLevel: null -> not distributor, 0 -> cancelled, 1-3 -> level
          this.distributorLevel = level
          this.hasPurchased = !!(level && level > 0)

        }
      } catch (err) {
        console.error('获取用户信息失败', err)
      }
    },
    async fetchPersonalOverview() {
      if (this.overviewLoading) return
      this.overviewLoading = true
      try {
        const res = await getPersonalOverview()
        const data = (res && res.data) || {}
        
        let collectionCount = Number(data.collectionCount || data.favoriteCount) || 0
        
        if (!collectionCount) {
          try {
            const favRes = await getMyFavorites({ pageNum: 1, pageSize: 1 })
            const favData = favRes && favRes.data
            if (favData && (favData.total != null)) {
              collectionCount = Number(favData.total) || 0
            } else if (Array.isArray(favData)) {
              collectionCount = favData.length
            }
          } catch (e) {
            console.error('获取收藏数量失败', e)
          }
        }
        
        this.overview = {
          certificateCount: Number(data.certificateCount) || 0,
          collectionCount,
          courseCount: Number(data.courseCount) || 0,
          goldCount: data.goldCount == null ? 0 : data.goldCount,
          unreadMessageCount: Number(data.unreadMessageCount) || 0,
          unusedCouponCount: Number(data.unusedCouponCount) || 0
        }
      } catch (err) {
        this.overview = {
          certificateCount: 0,
          collectionCount: 0,
          courseCount: 0,
          goldCount: 0,
          unreadMessageCount: 0,
          unusedCouponCount: 0
        }
      } finally {
        this.overviewLoading = false
      }
    }

  }
}
</script>

<style scoped lang="scss">
.page-container { min-height: 100vh; display: flex; flex-direction: column; background-color: #fff; }
.main-content { flex: 1; padding-top: 20px; }
.main-content.nested { margin-top: 0; }
.main-content.nested .page-inner-box { width: 100%; margin: 0; }

.my-courses-container {
  display: flex;
  gap: 24px;
}

.content-main {
  flex: 1;
}

/* User Top Bar (Removed) */

/* Stats Info */
.stats-info {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  padding: 20px 0;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 20px;
}

.stats-info.no-gold {
  grid-template-columns: repeat(4, 1fr);
}

.stat-item {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stat-label {
  font-size: 14px;
  color: #333;
  position: relative;
  margin-bottom: 8px;
  display: inline-flex;
  align-items: center;
}

.stat-badge-count {
  position: absolute;
  top: -8px;
  right: -20px;
  background-color: #ff4d4f;
  color: #fff;
  font-size: 12px;
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  border-radius: 8px;
  min-width: 16px;
  text-align: center;
}

.stat-value {
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

/* Courses Section */
.courses-section {
  padding: 0 0 20px 0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #3579f7; /* Blue color for title as per screenshot? Or just standard? Screenshot shows blue "我的课程" title text */
}

.exchange-btn {
  background-color: #3579f7;
  border-color: #3579f7;
  color: white;
  border-radius: 4px;
}

/* Course Grid */
.courses-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.course-card {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #eee;
  background: #fff;
  transition: all 0.3s;
  cursor: pointer;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
}

.card-inner {
  display: flex;
  flex-direction: column;
}

.course-image {
  height: 160px;
  background-color: #3d34eb; /* Deep Blue */
  width: 100%;
  position: relative;
  overflow: hidden;
}

.course-cover {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.course-content {
  padding: 12px;
}

.course-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.course-tags {
  margin-bottom: 12px;
}

.course-tag {
  display: inline-block;
  background-color: #e6f0ff;
  color: #3579f7;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}

.course-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price {
  color: #ff4d4f;
  font-size: 18px;
  font-weight: bold;
}

.lessons-count {
  color: #999;
  font-size: 12px;
}

/* Exchange Form */
.exchange-section {
  .exchange-header {
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .section-title {
      font-size: 16px;
      color: #3579f7;
      font-weight: bold;
    }
    
    .back-link {
      color: #666;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      
      i {
        margin-left: 4px;
      }
      
      &:hover {
        color: #3579f7;
      }
    }
  }

  .exchange-container {
    max-width: 600px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }
  
  .form-group {
    margin-bottom: 24px;
    width: 100%;
    
    &.verify-group {
      display: flex;
      gap: 16px;
      
      .custom-input {
        flex: 1;
      }
      
      .verify-btn {
        background-color: #4034eb;
        border-color: #4034eb;
        color: #fff;
        height: 50px;
        font-size: 16px;
        padding: 0 24px;
        border-radius: 4px;
      }
    }
  }
  
  .custom-input {
    ::v-deep .el-input__inner {
      height: 50px;
      line-height: 50px;
      border: 1px solid #eef0f6;
      background-color: #fcfcfc;
      border-radius: 4px;
      font-size: 14px;
      padding-left: 20px;
      
      &:focus {
        border-color: #4034eb;
      }
      
      &::placeholder {
        color: #999;
      }
    }
  }
  
  .exchange-result-card {
    background-color: #eeeafb;
    border-radius: 6px;
    padding: 24px 30px;
    margin-bottom: 24px;
    
    .result-row {
      margin-bottom: 12px;
      font-size: 14px;
      display: flex;
      line-height: 1.6;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .label {
        color: #666;
        width: 70px;
        flex-shrink: 0;
      }
      
      .val {
        color: #333;
        font-weight: 500;
      }
    }
  }
  
  .confirm-btn {
    width: 100%;
    height: 50px;
    background-color: #4034eb;
    border-color: #4034eb;
    font-size: 16px;
    margin-bottom: 40px;
    border-radius: 4px;
    
    &:hover {
      background-color: #554af0;
      border-color: #554af0;
    }
  }
  
  .usage-instructions {
    color: #666;
    font-size: 14px;
    line-height: 1.8;
    
    .instruction-title {
      margin-bottom: 8px;
    }
    
    p {
      margin: 4px 0;
    }
  }

  .redeem-records {
    margin-top: 24px;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .user-top-bar {
    flex-direction: column;
    align-items: flex-end;
    margin: 0;
    padding: 10px;
  }
  
  .stats-info {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
  
  .courses-grid {
    grid-template-columns: 1fr;
  }
}
</style>
